import { Injectable } from '@angular/core';
import { BehaviorSubject, from, Observable, Subject, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ConstantService } from '../constant/constant.service';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { LoadingOptions } from '@ionic/core';
import { LoadingController } from '@ionic/angular';
import { UtilService } from '../util/util.service';
import { environment } from 'src/environments/environment';
import { catchError, finalize, map, switchMap } from "rxjs/operators";
import { Store } from '@ngrx/store';
import { setAuthentication } from 'src/store/actions/authenticate';
import { AuthenticationService } from '../auth/authentication.service';
import { Auth } from 'aws-amplify';
import { ImageUploadService } from '../image-upload/image-upload.service';
import { setUser } from 'src/store/actions/user';
import { setIsChangeTrade, setSelectedTrade, setTradeData } from 'src/store/actions/trades';
import { setExpandsPlans, setPunchItem, setPunchItemLocation, setPunchItemsStore, setSelectedLocationPunchItems } from 'src/store/actions/punchItemDetail';
import { setActivityFilters,setActivityScheduledFilters, setJobsiteFilters } from 'src/store/actions/filters';
import { setIsChangeRoom, setRoomData } from 'src/store/actions/room';
import { setDescriptionData, setImportantDateDescription } from 'src/store/actions/description';
import { setDevelopmentData } from 'src/store/actions/development';
import { setTreeDetail } from 'src/store/actions/treeData';
import { setPlanDetail } from 'src/store/actions/planDetails';
import { setAlertsActiveLocationsLastupdate, setAlertsLocations, setScheduledLocations } from 'src/store/actions/alerts';
import { resetCoachMarks } from 'src/store/actions/coachMark';
import { setActiveLocations, setActiveLocationsLastupdate, setAllUserLocation, setLastContactFetch, setLocation, setLocationaImportantDates, setLocationJobsiteContacts, setPreviouslyUsedContacts, setUserLocalDataUpdate } from 'src/store/actions/location';
import { setSelectedLocation } from 'src/store/actions/location';
import { setLocationID } from 'src/store/actions/location';
import { setAlredyHaveLocation } from 'src/store/actions/location';
import { setAddressType } from 'src/store/actions/location';
import { setNavigationParameter } from 'src/store/actions/navigationVariables';
import { AnalyticsService } from '../analytics/analytics.service';
import { resetEncouragement } from 'src/store/actions/encouragement';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private loading!: HTMLIonLoadingElement;
  SERVICE_URL: string;
  FILE_UPLOAD_URL: string;
  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  token = '';
  auth: any;
  userData: any;
  loggingOut = false;
  private sessionPromise: Promise<any> | null = null;

  constructor(
    public constant: ConstantService,
    public http: HttpClient,
    public loadingController: LoadingController,
    public utility: UtilService,
    private router: Router,
    private store: Store<any>,
    private authServices: AuthenticationService,
    private imageUploadService: ImageUploadService,
    private analytics: AnalyticsService,
  ) {
    this.loadToken();
    this.apiInitConfig();
  }

  ionViewWillEnter() {
    //   get Token From Redux
    this.store.select<any>('auth').subscribe(state => this.auth = state);
    console.log(this.auth, "in enter")
  }

  apiInitConfig(): void {
    // this.SERVICE_URL = environment.baseUrl;
    this.SERVICE_URL = environment.baseUrl2;
    this.FILE_UPLOAD_URL = environment.fileUploadUrl;
  }

  /* Auth Guard Services */
  async loadToken() {
    this.store.select<any>('auth').subscribe(state => this.auth = state);
    const token = await this.auth?.authenticationData?.token?.sessionToken;
    if (token) {
      this.token = token;
      this.isAuthenticated.next(true);
    } else {
      this.isAuthenticated.next(false);
    }
  }

  async initiateAuthentiCation() {
    this.isAuthenticated.next(true);
  }

  async logoutAuthentication() {
    this.isAuthenticated.next(true);
  }

  private logging(requestUrl: any, requestType: any): void {
    this.store.select<any>('auth').subscribe(state => this.auth = state);
    console.log(`Request URL => ${this.SERVICE_URL}${requestUrl}`);
    console.log(`Request Type => ${requestType}`);
    console.log(
      `Token => ${this.auth?.authenticationData?.token?.sessionToken}`
    );
  }

  
  /** One in-flight Cognito session for parallel API calls (refresh once). */
  private getSession(): Promise<any> {
    if (!this.sessionPromise) {
      this.sessionPromise = Auth.currentSession().finally(() => {
        this.sessionPromise = null;
      });
    }
    return this.sessionPromise;
  }

  /** Fresh Cognito ID token (Amplify refreshes if ID/access expired). */
  async getIdToken(): Promise<string | null> {
    try {
      const session = await this.getSession();
      return session.getIdToken().getJwtToken();
    } catch (e) {
      console.error('getIdToken failed', e);
      return null;
    }
  }

  private async buildAuthHeaders(passHeaderToken: boolean): Promise<HttpHeaders> {
    let headers = new HttpHeaders();
    if (!passHeaderToken) {
      return headers;
    }

    try {
      const session = await this.getSession();
      const sessionToken = session.getIdToken().getJwtToken();
      const accessToken = session.getAccessToken().getJwtToken();
      const refreshToken = session.getRefreshToken().getToken();

      headers = headers.append('Authorization', 'Bearer ' + sessionToken);

      // Keep Redux token mirror in sync for legacy manual Bearer call sites
      const existing = this.auth?.authenticationData;
      if (existing) {
        await this.store.dispatch(setAuthentication({
          ...existing,
          token: {
            accessToken,
            sessionToken,
            refreshToken,
          },
          login: true,
        }));
      }

      return headers;
    } catch (e) {
      console.error('buildAuthHeaders failed — session expired', e);
      if (this.auth?.authenticationData?.login) {
        await this.forceLogout();
      }
      throw e;
    }
  }

  private showLoader(isShowLoading: any, loadingText: any): Promise<void> {
    if (isShowLoading) {
      return this.presentLoader(loadingText);
    }
    return null;
  }

  async presentLoader(_msg?: string): Promise<void> {
    const opts: LoadingOptions = {
      spinner: "bubbles",
      translucent: true,
      cssClass: "my-loading-class",
      duration: 500,
      backdropDismiss: true,
      animated: true,
      keyboardClose: true,
      message: _msg || "Please wait...",
      showBackdrop: true,
    };
    this.loading = await this.loadingController.create(opts);
    return this.loading.present();
  }

  dismissLoader(): Promise<boolean> {
    if (!this.loading) {
      return;
    }
    return this.loading.dismiss();
  }

  callApi(
    requestUrl: any,
    requestParams: any,
    requestType: any,
    loadingText: any,
    showLoading: Boolean,
    log: Boolean,
    passHeaderToken: Boolean,
  ): Observable<any> {
    this.showLoader(showLoading, loadingText);
    if (log) {
      this.logging(requestUrl, requestType);
    }

    if (requestType == "GET") {
      return this.callGETRequest(requestUrl, passHeaderToken);
    }
    if (requestType == "POST") {
      return this.callPOSTRequest(requestUrl, requestParams, passHeaderToken);
    }
    if (requestType == "PUT") {
      return this.callPUTRequest(requestUrl, requestParams, passHeaderToken);
    }
    if (requestType == "DELETE") {
      return this.callDELETERequest(requestUrl, requestParams, passHeaderToken);
    }
    return throwError(() => new Error(`Unsupported requestType: ${requestType}`));
  }

  callDELETERequest(requestUrl: any, requestParams: any, passHeaderToken: Boolean = true): Observable<any> {
    return from(this.buildAuthHeaders(!!passHeaderToken)).pipe(
      switchMap((headers) => {
        // Include body in DELETE request only if requestParams is provided and not empty
        const options: any = { headers };
        if (requestParams && requestParams !== "" && Object.keys(requestParams).length > 0) {
          options.body = requestParams;
        }

        return this.http.delete<any>(this.SERVICE_URL + requestUrl, options);
      }),
      finalize((): void => {
        this.dismissLoader();
      }),
      map((res: any): any => {
        this.dismissLoader();
        return res;
      }),
      catchError(this.handleError("error", []))
    );
  }

  callPUTRequest(requestUrl: any, requestParams: any, passHeaderToken: Boolean = true): Observable<any> {
    return from(this.buildAuthHeaders(!!passHeaderToken)).pipe(
      switchMap((headers) =>
        this.http.put<any>(this.SERVICE_URL + requestUrl, requestParams, { headers })
      ),
      finalize((): void => {
        this.dismissLoader();
      }),
      map((res: any): any => {
        this.dismissLoader();
        return res;
      }),
      catchError(this.handleError("error", []))
    );
  }

  callPOSTRequest(requestUrl: any, requestParams: any, passHeaderToken: Boolean = true): Observable<any> {
    return from(this.buildAuthHeaders(!!passHeaderToken)).pipe(
      switchMap((headers) =>
        this.http.post<any>(this.SERVICE_URL + requestUrl, requestParams, { headers })
      ),
      finalize((): void => {
        this.dismissLoader();
      }),
      map((res: any): any => {
        this.dismissLoader();
        return res;
      }),
      catchError(this.handleError("error", []))
    );
  }

  callGETRequest(requestUrl: any, passHeaderToken: Boolean = true): Observable<any> {
    return from(this.buildAuthHeaders(!!passHeaderToken)).pipe(
      switchMap((headers) =>
        this.http.get<any>(this.SERVICE_URL + requestUrl, { headers })
      ),
      finalize((): void => {
        this.dismissLoader();
      }),
      map((res: any): any => {
        this.dismissLoader();
        return res;
      }),
      catchError(this.handleError("error", []))
    );
  }

  customGETApi(url: any) {
    return this.http
      .get<any>(url)
      .pipe(
        finalize((): void => {
          this.dismissLoader();
        }),
        map((res: any): any => {
          this.dismissLoader();
          return res;
        }),
        catchError(this.handleError("error", []))
      );
  }

  private async forceLogout() {
    if (this.loggingOut) return;
    this.loggingOut = true;
    try {
      await this.authServices.signOut();
    } catch (e) {
      console.error('signOut failed', e);
    }
    try {
      this.analytics.reset();
      localStorage.clear();
      await this.store.dispatch(setAuthentication(null));
      await this.store.dispatch(setUser(null));
      await this.store.dispatch(setLocation(null));
      await this.store.dispatch(setSelectedLocation(null));
      await this.store.dispatch(setLocationID(null));
      await this.store.dispatch(setAlredyHaveLocation(null));
      await this.store.dispatch(setAddressType(null));
      await this.store.dispatch(setNavigationParameter(null));
      await this.store.dispatch(setTradeData(null));
      await this.store.dispatch(setIsChangeTrade(false));
      await this.store.dispatch(setSelectedTrade(null));
      await this.store.dispatch(setPunchItem(null));
      await this.store.dispatch(setPunchItemLocation(null));
      await this.store.dispatch(setSelectedLocationPunchItems(null));
      await this.store.dispatch(setActivityFilters(null));
      await this.store.dispatch(setActivityScheduledFilters(null));
      await this.store.dispatch(setJobsiteFilters(null));
      await this.store.dispatch(setRoomData(null));
      await this.store.dispatch(setIsChangeRoom(false));
      await this.store.dispatch(setActiveLocations(null));
      await this.store.dispatch(setActiveLocationsLastupdate(null));
      await this.store.dispatch(setAllUserLocation(null));
      await this.store.dispatch(setDescriptionData(null));
      await this.store.dispatch(setImportantDateDescription(null));
      await this.store.dispatch(setDevelopmentData(null));
      await this.store.dispatch(setTreeDetail(null));
      await this.store.dispatch(setPunchItemsStore(null))
      await this.store.dispatch(setUserLocalDataUpdate(null))
      await this.store.dispatch(setExpandsPlans(null))
      await this.store.dispatch(setPreviouslyUsedContacts(null))
      await this.store.dispatch(setLastContactFetch(null));
      await this.store.dispatch(setPlanDetail(null));
      await this.store.dispatch(setLocationJobsiteContacts(null));
      await this.store.dispatch(setLocationaImportantDates(null));
      await this.store.dispatch(setAlertsLocations(null));
      await this.store.dispatch(setScheduledLocations(null));
      await this.store.dispatch(setAlertsActiveLocationsLastupdate(null));
      await this.store.dispatch(resetCoachMarks());
      await this.store.dispatch(resetEncouragement());
    } catch (e) {
      console.error('clear state failed', e);
    }
    this.isAuthenticated.next(false);
    this.router.navigateByUrl('/home', { replaceUrl: true });
    this.loggingOut = false;
  }

  // uploadImage(url, data) {
  //   var formData = new FormData();
  //   formData.append("image", data.file)
  //   formData.append("location", data.location);
  //   return this.http.post(this.FILE_UPLOAD_URL + url, formData, {});
  //   // return this.http.post(this.SERVICE_URL + url, formData, {});
  // }

  uploadImage(_url: string, data: { file: File | Blob; location: string; fileName?: string }) {
    const fileName = data.fileName || (data.file instanceof File ? data.file.name : 'photo.jpg');
    
    return this.imageUploadService.upload(data.file, data.location, fileName);
  }

  private handleError<T>(
    _operation = "operation",
    _result?: T
  ): (error: any) => Observable<T> {
    return (error: any): Observable<T> => {
      if (error.status == 401 && this.auth?.authenticationData?.login) {
        // Amplify should have refreshed before the request. 401 here usually means no valid Cognito session (refresh failed / signed out)
        console.log('Unauthorized — Cognito session missing or refresh failed');
        this.forceLogout();
      }
      // Content Safety Master Spec §14. Chat sends and punch-item comments both
      // route through here, so the refusal is shown once rather than in each
      // page's error branch. Wording comes from the API so it stays in step
      // with the spec.
      if (error?.error?.error === "ERR_CONTENT_BLOCKED") {
        this.utility.presentBlockedToast(
          error.error.title || "Message couldn't be sent",
          error.error.message
        );
      }

      this.dismissLoader();
      return throwError(error);
    };
  }
}
